module.exports = __webpack_public_path__ + "Roboto-BoldItalic.076a5afdf7124a39734c.ttf";


//////////////////
// WEBPACK FOOTER
// /home/leonhard/Projekte/braungardt/angular/src/assets/font/Roboto-BoldItalic.ttf
// module id = ../../../../../src/assets/font/Roboto-BoldItalic.ttf
// module chunks = styles